"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _hooks = require("../../hooks");
var _Site = require("./Site.config");
var useStyles = function useStyles(props) {
  var header = props.header,
    sideBar = props.sideBar;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var ccSiteStyle = (0, _react.useMemo)(function () {
    var ccSite = (0, _css.css)({
      minHeight: '100vh',
      position: 'relative',
      background: '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      fontFamily: fontFamily
    });
    var ccSiteSideBar = (0, _css.css)({
      position: 'fixed',
      zIndex: 10,
      width: isMobileView ? '100vw' : pxToRem(_Site.sidebarWidth),
      height: isMobileView ? pxToRem(_Site.sidebarHeight) : undefined,
      top: header ? isMobileView ? 'auto' : pxToRem(_Site.headerHeight) : 0,
      bottom: isMobileView ? 0 : 0,
      left: isMobileView ? 0 : undefined,
      right: isMobileView ? 0 : undefined
    });
    var ccSitePageContent = (0, _css.css)({
      position: 'relative',
      backgroundColor: '#f0f1f6',
      borderTopRightRadius: pxToRem(6),
      minHeight: "calc(100vh - ".concat(pxToRem(isMobileView ? 100 : _Site.headerHeight), ")"),
      marginTop: pxToRem(_Site.headerHeight),
      marginInlineStart: !isMobileView && sideBar ? pxToRem(_Site.sidebarWidth) : 0,
      marginBottom: isMobileView && sideBar ? pxToRem(_Site.sidebarHeight) : 0
    });
    return {
      ccSite: ccSite,
      ccSiteSideBar: ccSiteSideBar,
      ccSitePageContent: ccSitePageContent
    };
  }, [fontFamily, isMobileView, header, sideBar, pxToRem]);
  return {
    'cc-Site': ccSiteStyle.ccSite,
    'cc-Site__side-bar': ccSiteStyle.ccSiteSideBar,
    'cc-Site__page-content': ccSiteStyle.ccSitePageContent
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;